import { useLocale } from '~/composables/useStates/useLocale';

export default defineNuxtPlugin({
  name: 'locale',
  parallel: true,
  setup: () => {
    const locale = useLocale();
    const { localeKey, interpolationLocaleKey } = useLocaleUtils();
    window.$t = (k: string) => localeKey(k.toLowerCase());
    return {
      provide: {
        t: (k: string, a?: string) =>
          localeKey(k.toLowerCase(), a?.toLowerCase()),
        i: (k: string, p: Record<string, string>) =>
          interpolationLocaleKey(k.toLocaleLowerCase(), p),
        locale,
      },
    };
  },
});
